module.exports = __webpack_public_path__ + "img/fa7f001.jpg";